module.exports = __webpack_public_path__ + "img/ico_arrow_up_white.1a8a8949.svg";